
























import Vue from "vue"
import { vueWith } from "./../vueWith"

/**
 * @example
 *  <hour-component
 *    v-model="hour"
 *    class="select"
 *    v-bind:class="{ none: radio == 1 || frequency != 1 }"
 *  ></hour-component>
 */
export default vueWith<{
  // $refs: { table: TableComponentMethods },
}>().extend({
  components: {
    // TableComponent,
  },
  props: {
    value: String,
  },
  data() {
    return {
      // value: "-1",
    }
  },

  computed: {
  },

  /** Vue構築完了時の処理 */
  created: function init() {
    //
  },

  // mounted: function mount() {
  //   console.log(this.value)
  //   this.$emit("input", this.value)
  // },

  methods: {

    updateValue(e: any) {
      // console.log(e.target!.value)
      this.$emit("input", e.target!.value)
    },

    // 子から呼ばれる ---------------------------------------------

  },
})


